import { createFileRoute } from "@tanstack/react-router";
import { bookmarkListInfiniteQueryOptions } from "~/features/favorites/api";
import { BookmarkListTemplate } from "~/features/favorites/BookmarkListTemplate";

export const Route = createFileRoute("/_authenticated/profile/bookmarks")({
  loader: ({ context: { queryClient } }) =>
    queryClient.ensureInfiniteQueryData(bookmarkListInfiniteQueryOptions),
  component: BookmarkListTemplate,
});
